import React from 'react'
import { connect } from 'react-redux'
import { styled } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'
import { EmojiEvents } from '@mui/icons-material'
import classNames from 'classnames'
import './Below.scss'

const BelowBox = styled(Box)(
  ({ theme }) => `
  .win-times {
    color: ${theme.palette.player.additional};
  }
`
)

const Below = ({ score, rule }) => {
  const win = key => (
    <EmojiEvents key={key} fontSize="small" className="win" />
  )

  return (
    <BelowBox className={classNames('below', { hidden: !rule.other.showWinTimes })}>
      <Box className="win-times">
        {score.winTimes > 5 ? win(0) : Array(score.winTimes).fill(0).map((_, i) => win(i))}
        {score.winTimes > 5 && <Typography variant="body2">× {score.winTimes}</Typography>}
      </Box>
    </BelowBox>
  )
}

export default connect(
  state => ({
    rule: state.rule
  })
)(Below)
